// extracted by mini-css-extract-plugin
export default {"confirmationModal":"styles_confirmationModal__cUcWq"};